



































































































































































































import {
  faCamera,
  faExclamationTriangle,
  faShareAlt,
  faEllipsisV,
  faSearch,
  faPrint,
  faWrench,
  faCompressAlt
} from '@fortawesome/free-solid-svg-icons'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import CContextMenu from '~/components/shared/configurable/CContextMenu.vue'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { USER_NS } from '~/store/modules/shared/user/state'
import { SET_BIG_PHOTOS_VISIBLE } from '~/store/modules/shared/classifieds/view/mutation-types'
import CClassifiedFavoriteButton from '~/components/shared/configurable/classified/bucket/favorite/CClassifiedFavoriteButton.vue'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import ClassifiedReportService from '~/services/report/classified/ClassifiedReportService'
import { ciPlot } from '~/icons/source/brand/plot'
import CClassifiedCompareButton from '~/components/shared/configurable/classified/compare/CClassifiedCompareButton.vue'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import { ciList } from '~/icons/source/solid/list'
import { ciNotes } from '~/icons/source/regular/notes'
import {
  defineComponent,
  defineVue3AsyncComponent
} from '~/utils/nuxt3-migration'
import CAnonGuardModal from '~/components/shared/configurable/user/CAnonGuardModal.vue'
import DealerSiteService from '~/services/dealers/site/DealerSiteService'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'

export default defineComponent({
  components: {
    CConfirmationModal,
    CAnonGuardModal,
    CClassifiedFavoriteButton,
    CContextMenu,
    ReportModalInfo: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/ReportModalInfo.vue')
    ),
    ShareModal: defineVue3AsyncComponent(() => import('./ShareModal.vue')),
    CClassifiedListModal: defineVue3AsyncComponent(() =>
      import(
        '~/components/shared/configurable/classified/list/CClassifiedListModal.vue'
      )
    ),
    CClassifiedNotesModal: defineVue3AsyncComponent(() =>
      import(
        '~/components/shared/configurable/classified/note/CClassifiedNotesModal.vue'
      )
    ),
    CReportModal: defineVue3AsyncComponent(() =>
      import('~/components/shared/configurable/modal/CReportModal.vue')
    ),
    CClassifiedCompareButton
  },
  props: {
    categoryId: { type: Number, required: false, default: null }
  },
  data() {
    return {
      reportModalVisible: false,
      shareModalVisible: false,
      listsModalVisible: false,
      notesModalVisible: false,
      showConvertConfirm: false,
      anonGuardModalVisible: false
    }
  },
  computed: {
    icons() {
      return {
        camera: faCamera,
        share: faShareAlt,
        report: faExclamationTriangle,
        ellipsis: faEllipsisV,
        search: faSearch,
        print: faPrint,
        wrench: faWrench,
        plot: ciPlot,
        compare: faCompressAlt,
        notes: ciNotes,
        list: ciList
      }
    },
    ...mapState(CLASSIFIED_VIEW_NS, {
      classifiedId: state => state.classifiedId,
      classified: state => state.classified,
      otherClassifieds: state => state.classified.other_classifieds,
      similarClassifieds: state => state.classified?.similar_classifieds,
      nativePhotos: state => state.classified.compactPhotos.native.photos,
      partsForVehicle: state => state.classified.parts_for_vehicle,
      currentUser: state => state.currentUser
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      showMoreClassifiedsFromUser: 'showMoreClassifiedsFromUser',
      isPlotClassified: 'isPlotClassified',
      isVehicleClassified: 'isVehicleClassified',
      isMapVariant: 'isMapVariant',
      userIsOwner: 'isOwn',
      isNonPublic: 'isNonPublic',
      isHidden: 'isHidden',
      isDeleted: 'isDeleted',
      isRemoved: 'isRemoved',
      userCanViewNotes: 'userCanViewNotes',
      processedPhotos: 'processedPhotos'
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    }),
    ...mapGetters(USER_NS, {
      userIsAdmin: 'isAdmin',
      isSingleOrAnon: 'isSingleOrAnon'
    }),
    printAvailable() {
      return typeof window !== 'undefined' && window.print
    },
    convertToPartUrl() {
      const legacyUrlService = this.$dep(LegacyUrlService)
      return legacyUrlService.getConvertToPartUrl(this.classifiedId)
    },
    classifiedReportService() {
      return this.$dep(ClassifiedReportService)
    },
    analyticsMapping() {
      const analyticsMap = {
        mobile: {
          share: 'n_util_buttons_mobile_share',
          report: 'n_util_buttons_mobile_report',
          list: 'n_util_buttons_mobile_list_in_classified',
          notes: 'n_util_buttons_mobile_notes'
        },
        desktop: {
          share: 'n_util_buttons_desktop_share',
          report: 'n_util_buttons_desktop_report',
          list: 'n_util_buttons_desktop_list_in_classified',
          notes: 'n_util_buttons_desktop_notes'
        }
      }
      return analyticsMap[this.getDevice]
    },
    getDevice() {
      return this.isMobile ? 'mobile' : 'desktop'
    },
    isDealerSite() {
      const dealerSiteService = this.$dep(DealerSiteService)
      return dealerSiteService.routeIsOfDealerSite()
    }
  },
  methods: {
    ...mapMutations(CLASSIFIED_VIEW_NS, {
      setBigPhotosVisible: SET_BIG_PHOTOS_VISIBLE
    }),
    ...mapActions(CLASSIFIED_VIEW_NS, {
      classifiedParkedStateChanged: 'classifiedParkedStateChanged'
    }),
    print() {
      window.print()
    },
    onConvertConfirm() {
      window.location.href = this.convertToPartUrl
    },
    showSharePopup() {
      this.shareModalVisible = true
      this.$analytics.recordEvent({
        namespace: this.analyticsMapping.share,
        action: 'click'
      })
    },
    showReportModal() {
      this.reportModalVisible = true
      this.$analytics.recordEvent({
        namespace: this.analyticsMapping.report,
        action: 'click'
      })
    },
    showListsModal() {
      this.$analytics.recordEvent({
        namespace: this.analyticsMapping.list,
        action: 'click',
        label: this.classified.title + ' (' + this.classified.id + ')'
      })
      this.listsModalVisible = true
    },
    onModalClose() {
      this.shareModalVisible = false
      this.reportModalVisible = false
    },
    handleReportModalVisibilityChange(newModalVisibility) {
      this.reportModalVisible = newModalVisibility
    },
    handleShareModalVisibilityChange(newModalVisibility) {
      this.shareModalVisible = newModalVisibility
    },
    handleClickNotes() {
      this.$analytics.recordEvent({
        namespace: this.analyticsMapping.notes,
        action: 'click',
        label: this.classified.title + ' (' + this.classified.id + ')'
      })
      if (this.isSingleOrAnon) {
        this.anonGuardModalVisible = true
      } else {
        this.notesModalVisible = true
      }
    }
  }
})
